/**
 * @function
 * @name loadScript
 * @param {string} src
 * @param {object} [opts] optional
 * @returns {promise} resolve or reject - 예외처리는 사용하는 쪽에서 진행....
 */

const urlWithoutProtocol = (str) => {
  // new URL을 쓸 수가 없음
  // loadScript의 src에 프로토콜이 없어서 new URL로 파싱할 때 에러가 발생
  const num = str.indexOf('//');
  return str.slice(num + 2);
};

const checkInstalled = (src) => {
  let installed = false;
  const scriptList = window.document.querySelectorAll('script');
  scriptList.forEach((script) => (installed = installed || urlWithoutProtocol(script.src) === urlWithoutProtocol(src)));
  return installed;
};

export const loadScript = (src, opts) => {
  return new Promise((resolve, reject) => {
    if (checkInstalled(src)) {
      return reject('REJECTED: Already Installed');
    }
    const el = document.createElement('script');
    el.src = src;
    el.async = opts && opts.async;
    el.defer = opts && opts.defer;
    el.onload = resolve;
    el.onerror = reject;
    (document.querySelector('head') || document.body).appendChild(el);
  });
};
